module.exports = __webpack_public_path__ + "static/media/ship.72c20e1a.svg";